
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Orders</h2>
      <breadcrumbs [breadcrumbs]="breadcrumbs"></breadcrumbs>
      <!--ol.breadcrumb
      li.breadcrumb-item
        a([routerLink]="['/projects']") Projects
      li.breadcrumb-item(*ngIf='orders[0]?.projectId && orders[0]?.projectName')
        a([routerLink]="['/project']", [queryParams]="{id: orders[0]?.projectId}") {{ orders[0]?.projectName }}
      li.breadcrumb-item(*ngIf='orders[0]?.projectId && orders[0]?.projectName')
        a([routerLink]="['/sites']", [queryParams]="{projectId: orders[0]?.projectId}") Sites
      li.breadcrumb-item(*ngIf='siteId && orders[0]?.siteName')
        a([routerLink]="['/site']", [queryParams]="{id: siteId}") {{ orders[0]?.siteName }}
      li.breadcrumb-item.active(*ngIf='!siteId || !orders[0]?.siteName') All
      li.breadcrumb-item.active Orders
      -->
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <list-controls [pageName]="'Orders'" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)">
        <button class="btn btn-primary" id="createOrder" (click)="create()">Create Order</button>
      </list-controls>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row" *ngFor="let order of orders; let i = index">
        <div class="col">
          <div class="card-item">
            <div class="card-order-status float-right">
              <property-container class="font-30 red">
                <property-item [showIf]="order.pastSchedule"><span class="oi oi-clock" title="{{ order.statusMessage }}"></span></property-item>
              </property-container>
              <property-container class="font-30 green" *ngIf="!order.pastSchedule &amp;&amp; !order.rejected &amp;&amp; order.orderComplete">
                <property-item [showIf]="!order.pastSchedule &amp;&amp; order.orderComplete"><span class="oi oi-check" title="{{ order.statusMessage }}"></span></property-item>
              </property-container>
            </div>
            <h4>{{ order.name }}<span class="badge ml-1" *ngIf="order.rejected" [ngClass]="{'badge-warning': true}">Rejected</span></h4>
            <div class="float-left">
              <property-container>
                <property-item><a id="orderDetails{{i}}" [href]="'/#/order?id=' + order.id">Details</a></property-item>
                <property-item><a id="setUpOrder{{i}}" [href]="'/#/workflow/' + order.workflowId">Set Up Order</a></property-item>
              </property-container>
              <property-container>
                <property-item><span>Assets: {{ order.plannedAssets }}</span></property-item>
                <property-item><span>Accessories: {{ order.plannedAccessories }}</span></property-item>
              </property-container>
              <property-container>
                <property-item [showIf]="order.hardwareOrderDate">Hardware Order Date: {{ order.hardwareOrderDate | date: 'yyyy-MM-dd' : 'UTC'}}</property-item>
              </property-container>
              <property-container class="red">
                <property-item [showIf]="order.pastSchedule"><span class="oi oi-clock"></span> {{ order.pastScheduleMessage }}</property-item>
              </property-container>
            </div>
            <div class="float-right">
              <property-container>
                <property-item [showIf]="!!order.hardwareOrderDetails?.length"><span>Order Numbers & Dates:</span>
                  <ng-template ngFor let-element [ngForOf]="order.hardwareOrderDetails"><br><span>{{ element.orderNumber }} {{ element.orderDate | date: 'yyyy-MM-dd' : 'UTC' }}</span></ng-template>
                </property-item>
              </property-container>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>